import { Model } from "@vuex-orm/core";

export class MClass extends Model {
    static get entity() {
        return "m_classs"
    }

    static fields() {
        return {
            "id": this.attr(null),
            "m_class_name": this.string(""),
            "create_by": this.attr(null),
            "update_by": this.attr(null),
            "createdAt": this.attr(null),
            "updatedAt": this.attr(null)
        }
    }

    static get apiConfig() {
        return {
            actions: {
                findAll(params = {}) {
                    return this.get('/m_class', { params });
                }
            }
        };
    }
}